var _style, _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.1 20.4",
    style: {
      enableBackground: "new 0 0 41.1 20.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:#FFFFFF;}\n    .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n    .st2{clip-path:url(#SVGID_00000172401921286239880950000009042436506550689929_);}\n    .st3{clip-path:url(#SVGID_00000167365517727625592040000002763617286592704912_);}\n    .st4{fill:#F2F2F2;}\n    .st5{fill:#BDB6B8;}\n    .st6{fill:#1A1A1A;}\n    .st7{fill:#ADA8AA;}\n    .st8{fill:#262424;}\n    .st9{fill:#1E8273;}\n    .st10{fill:#239281;}\n    .st11{fill:#262626;}\n    .st12{fill:#0F0F0F;}\n    .st13{fill:#212226;}\n    .st14{opacity:0.25;}\n    .st15{clip-path:url(#SVGID_00000021121546953713027410000002261599760338368695_);}\n    .st16{opacity:0.15;}\n    .st17{clip-path:url(#SVGID_00000067217339536654895800000000827166590022151842_);}\n    .st18{clip-path:url(#SVGID_00000001623485152907001280000007675208560540426159_);}\n    .st19{clip-path:url(#SVGID_00000016040145328130344760000001398210435389268148_);}\n    .st20{clip-path:url(#SVGID_00000094607853204809263440000000057090059308723097_);}\n    .st21{clip-path:url(#SVGID_00000107561730921533289980000016613903160640968328_);}\n    .st22{fill:#2B5896;}\n    .st23{fill:#D71C13;}\n    .st24{fill:#FF2116;}\n    .st25{fill:#92130D;}\n    .st26{fill:#F5F5F5;}\n    .st27{fill:url(#);}\n    .st28{fill:#1D7244;}\n    .st29{fill:#FFFFFF;enable-background:new    ;}\n    .st30{fill:#207044;enable-background:new    ;}\n    .st31{fill:#0D6735;}\n    .st32{fill:#FDFDFD;}\n    .st33{clip-path:url(#SVGID_00000016073220293438706680000017271707012995733663_);}\n    .st34{clip-path:url(#SVGID_00000149346608702991972400000002542480392535022778_);}\n    .st35{clip-path:url(#SVGID_00000174576470497011015940000012125413522286549426_);}\n    .st36{clip-path:url(#SVGID_00000109733346660738355450000011683883529866275214_);}\n    .st37{clip-path:url(#SVGID_00000086661193848300991640000016131753650120739733_);}\n    .st38{clip-path:url(#SVGID_00000145060154269662357970000018166222535612474038_);}\n    .st39{clip-path:url(#SVGID_00000051345402571834015410000014119644664549756559_);}\n    .st40{clip-path:url(#SVGID_00000007413609631269150740000012633942308563611277_);}\n    .st41{fill:#ea3943;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000167389179359298595910000005326610812839826830_",
    width: 41.1,
    height: 20.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077318857815234453760000000576924839365220499_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000167389179359298595910000005326610812839826830_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4910-2",
    style: {
      clipPath: "url(#SVGID_00000077318857815234453760000000576924839365220499_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7760",
    className: "st41",
    d: "M40.4,8.5c-0.4,0-0.7-0.3-0.7-0.7c0-3.5-2.9-6.4-6.4-6.4c-0.4,0-0.7-0.3-0.7-0.7             c0-0.4,0.3-0.7,0.7-0.7c4.3,0,7.8,3.5,7.8,7.8C41.1,8.2,40.8,8.5,40.4,8.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7761",
    className: "st41",
    d: "M37.7,8.5c-0.4,0-0.7-0.3-0.7-0.7c0-2.1-1.7-3.7-3.7-3.7c-0.4,0-0.7-0.3-0.7-0.7             s0.3-0.7,0.7-0.7c0,0,0,0,0.1,0c2.9,0,5.2,2.3,5.2,5.2C38.5,8.2,38.1,8.5,37.7,8.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7762",
    className: "st41",
    d: "M33.4,20.4H2.6c-1.4,0-2.6-1.2-2.6-2.6c0,0,0,0,0,0v-10c0-1.4,1.2-2.6,2.6-2.6c0,0,0,0,0,0             h30.8c1.4,0,2.6,1.2,2.6,2.6c0,0,0,0,0,0v10C35.9,19.2,34.8,20.4,33.4,20.4C33.4,20.4,33.4,20.4,33.4,20.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7763",
    className: "st0",
    d: "M9.4,15.1v2.6H2.9V8h2.9v7.1L9.4,15.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1247",
    x: 11,
    y: 8,
    className: "st0",
    width: 2.9,
    height: 9.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7764",
    className: "st0",
    d: "M25.3,8L22,17.7h-3.6L15.2,8h3.1l1.9,6.9L22.2,8L25.3,8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7765",
    className: "st0",
    d: "M33.2,15.3v2.4h-6.6V8h6.5v2.4h-3.6v1.3h3.2v2.3h-3.2v1.4L33.2,15.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.014b69d9e313b8f033fa73de88426650.svg";
export { ForwardRef as ReactComponent };